import {AddItemResponseStatus_Success_Section} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/add_item_status.types';

export const getPromotionInvalidFromSections = (
  statusSuccessSections: AddItemResponseStatus_Success_Section[],
) => {
  for (const section of statusSuccessSections) {
    if (section.type?.$case === 'promotionInvalid') {
      return section.type.promotionInvalid;
    }
  }
};
